import RouterHelper from "../../helpers/router-helper";

import About from "../../pages/About";
import Filters from "../../pages/Filters";

import Facilities from "../../pages/Facilities";
import Offering from "../../pages/Offering";
import Contact from "../../pages/Contact";

import Horse from "../../pages/horse";
import Feeds from "../../pages/Feeds";

const meta = {
  language: "eng",
  flag: "us",
};

export default [
  {
    path: "/about",
    component: About,
    meta,
  },
  {
    path: "/horses",
    component: RouterHelper,
    children: [
      {
        path: "",
        component: Filters,
        meta,
      },
      {
        path: ":horse",
        component: Horse,
        meta,
      },
    ],
  },
  {
    path: "/facilities",
    component: Facilities,
    meta,
  },
  {
    path: "/offering",
    component: Offering,
    meta,
  },
  {
    path: "/feeds",
    component: Feeds,
    meta,
  },
  {
    path: "/contact",
    component: Contact,
    meta,
  },
];
